import { FC, ReactElement } from 'react';
import { ListItemProps } from './List.interface';
import cn from 'utils/cn';

const ListItem: FC<ListItemProps> = ({
  children,
  liProps = {},
  noHover = false,
}): ReactElement<any> => {
  return (
    <li
      {...liProps}
      className={cn(
        `mume-list-item tw:px-6 tw:border-b-1 tw:border-primary-400 tw:flex tw:items-center tw:h-[40px]`,
        liProps?.className,
        noHover ? '' : 'tw:hover:border-accent-100'
      )}
    >
      {children}
    </li>
  );
};

export default ListItem;
